const windowSize = {};
const setupSize = () => {
    windowSize.width = window.innerWidth;
    windowSize.height = window.innerHeight;
};
setupSize();
window.addEventListener('resize', setupSize);

export default windowSize;
